import * as React from 'react';
import { connect } from 'react-redux';
import { expandCollapseManager } from '@wix/chat-web';
import wix from '../../services/wix';
import {
  ViewerOnWidgetCollapsed,
  ViewerOnWidgetExpand,
} from '../../constants/viewer-event-types';
import {
  getChatSettings,
  getChatState,
  sendMessage,
  focusChannel,
  getChannel,
  startChannel,
} from '../../actions';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { wixAnalytics } from '../../services/wixAnalytics';

interface RootProps extends InjectedExperimentsProps {
  getChatState(data): any;
  getChatSettings(data): any;
  sendMessage(data): any;
  focusChannel(data): any;
  getChannel(data): any;
  startChannel(data): any;
}

interface RootState {}

class _Root extends React.Component<RootProps, RootState> {
  handleExpandWidgetRequest(options: any = {}) {
    const requestId = options.data ? options.data.requestId : undefined;

    expandCollapseManager.registerOnExpand(() => {
      if (requestId) {
        const expandWidgetResponseEvent = `ChatWidget.expandWidgetResponse.${requestId}`;
        wix.publishToPubSub(expandWidgetResponseEvent, { success: true });
      }
    });

    expandCollapseManager.expand();
  }

  handleCollapseWidgetRequest(options: any = {}) {
    const requestId = options.data ? options.data.requestId : undefined;

    expandCollapseManager.registerOnCollapse(() => {
      const collapseWidgetResponseEvent = `ChatWidget.collapseWidgetResponse.${requestId}`;
      wix.publishToPubSub(collapseWidgetResponseEvent, { success: true });
    });

    expandCollapseManager.collapse();
  }

  handleSendMessageRequest = ({ data }) => {
    this.props.sendMessage(data);
  };

  handleGetChatStateRequest = ({ data }) => {
    this.props.getChatState(data);
  };

  handleGetChatSettingsRequest = ({ data }) => {
    this.props.getChatSettings(data);
  };

  handleFocusChannelRequest = ({ data }) => {
    this.props.focusChannel(data);
  };

  handleGetChannelRequest = ({ data }) => {
    this.props.getChannel(data);
  };

  handleStartChannelRequest = ({ data }) => {
    this.props.startChannel(data);
  };

  trackExpand = () => {
    wixAnalytics.expand();
  };

  trackCollapse = () => {
    wixAnalytics.collapse();
  };

  registerTrackEvents() {
    expandCollapseManager.registerOnExpand(this.trackExpand);
    expandCollapseManager.registerOnCollapse(this.trackCollapse);
  }

  unRegisterTrackEvents() {
    expandCollapseManager.unregisterOnExpand(this.trackExpand);
    expandCollapseManager.unregisterOnCollapse(this.trackCollapse);
  }

  componentDidMount() {
    wix.subscribeToExpandWidgetRequest(this.handleExpandWidgetRequest);
    wix.subscribeToCollapseWidgetRequest(this.handleCollapseWidgetRequest);

    wix.subscribeToGetChatStateRequest(this.handleGetChatStateRequest);
    wix.subscribeToGetChatSettingsRequest(this.handleGetChatSettingsRequest);

    wix.subscribeToSendMessageRequest(this.handleSendMessageRequest);

    wix.subscribeToFocusChannelRequest(this.handleFocusChannelRequest);

    wix.subscribeToGetChannelRequest(this.handleGetChannelRequest);

    wix.subscribeToStartChannelRequest(this.handleStartChannelRequest);

    this.registerTrackEvents();

    expandCollapseManager.registerOnExpand(() => {
      wix.publishToPubSub(ViewerOnWidgetExpand, {});
    });
    expandCollapseManager.registerOnCollapse(() => {
      wix.publishToPubSub(ViewerOnWidgetCollapsed, {});
    });
  }

  componentWillUnmount() {
    this.unRegisterTrackEvents();
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getChatState: data => dispatch(getChatState(data)),
    getChatSettings: data => dispatch(getChatSettings(data)),
    sendMessage: data => dispatch(sendMessage(data)),
    focusChannel: data => dispatch(focusChannel(data)),
    getChannel: data => dispatch(getChannel(data)),
    startChannel: data => dispatch(startChannel(data)),
  };
};

function mapStateToProps(state) {
  return {};
}

export const Root = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withExperiments(_Root));
